import { Button, Text, Link, Stack, ListItem, UnorderedList } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { REGISTER_PAGE_PATH } from '@/routes/path';
import PlanItem from '../PlanItem';
import { PlanProps } from '../types';
import FreePlanBreakdown from './FreePlanBreakdown';
import FreePlanCover from './FreePlanCover';

const IndividualPlan: React.VFC<PlanProps> = ({ t, language }) => {
  return (
    <PlanItem
      breakdown={<FreePlanBreakdown language={language} t={t} />}
      cover={<FreePlanCover language={language} t={t} />}
      footer={<Link></Link>}
      // footer={
      //   <Link as={RouterLink} target="_blank" to={REGISTER_PAGE_PATH} variant="no-decoration">
      //     <Button colorScheme="blue" rounded="full" variant="invert-solid" w="100%" size="md">
      //       {t('sign_up_landing_page')}
      //     </Button>
      //   </Link>
      // }
      title={t('free_tier')}
    />
  );
};

export default IndividualPlan;
